export default __webpack_public_path__ + "static/media/Hair_11_M_C2.8477c1c3.svg";